import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Send } from '@vedmarket/ui-kit'

import { COLORS } from '../../../../config/constants'

const AccountAction = ({ accountActionUrl, isRegistered }: DemoAccountProps) => {
  const { t } = useTranslation()

  return (
    <Box
      className='demo-account-action'
      sx={{
        width: '100%',
        minWidth: 0
      }}
    >
      <Button
        fullWidth
        variant='contained'
        href={accountActionUrl}
        target='_blank'
        rel='noreferrer'
        startIcon={<Send />}
        data-demo-allowed='registration'
        sx={{
          '&:hover': {
            backgroundColor: COLORS.WHITE,
            color: COLORS.BLUE
          },
          '@media (max-width: 767px)': {
            minHeight: 40,
            '& .MuiButton-startIcon': {
              display: 'none'
            },
          },
          '@media (max-width: 575px)': {
            width: '100%',
          },
          '@media (min-width: 768px) and (max-width: 1199px)': {
            minHeight: 48
          },
          backgroundColor: COLORS.WHITE,
          color: COLORS.BLACK_DARK,
          minHeight: 56,
        }}
      >
        <Typography
          variant='button'
          sx={{
            letterSpacing: '1px',
            lineHeight: '24px'
          }}
        >
          {t(isRegistered ? 'calc__text__demoFooterCabinetButton' : 'calc__text__demoRegisterButton')}
        </Typography>
      </Button>
    </Box>
  )
}

export default AccountAction
